/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

import Vue from 'vue';
import Store from '@/search-app/store';
import Router from '@/search-app/router';
import App from '@/search-app/App';
import Blue from '../js/core';
import VueScrollTo from 'vue-scrollto';

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Blue({
	name: 'search-app',
	selector: '#search-app',
	setup(el) {
		const app = new Vue({
			store: new Store().store,
			router: new Router().router,
			data: () => Object.assign({}, el.dataset),
			render: h => h(App)
		});

		Vue.use(VueScrollTo, {
			container: "body",
			duration: 750,
			easing: "ease",
			offset: 0,
			force: true,
			cancelable: false,
			onStart: false,
			onDone: false,
			onCancel: false,
			x: false,
			y: true
		})

		app.$mount(el)
	}
}, false)